import axios from "axios";
//export const ApiUrl: string = (process.env.REACT_APP_API_URL !== undefined) ? process.env.REACT_APP_API_URL : 'https://cf77-13-48-13-238.ngrok-free.app/'
export const ApiUrl: string = (process.env.REACT_APP_API_URL !== undefined) ? process.env.REACT_APP_API_URL :'https://staging.alliance-crm.com'
//export const ApiUrl: string = (process.env.REACT_APP_API_URL !== undefined) ? process.env.REACT_APP_API_URL :'http://localhost:8080'

const path = '/callcenter/admin'

let token = localStorage.getItem('token')
let headers

if(token !== null){
  headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+ token
  }
}else{
  headers = { 'Content-Type': 'application/json' }
}

export default axios.create({
    baseURL: ApiUrl+path,
    responseType: "json",
    headers: headers
});